import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block2-生成图文1.png")